/** The offer and the risk disclosure in force, and whether the client accepted them. */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { readLegalDocuments, type LegalDocumentsResponse } from "@/shared/api";

export const LEGAL_KEY = ["legal-documents"] as const;

export function useLegalDocuments(enabled = true): UseQueryResult<LegalDocumentsResponse> {
  return useQuery({
    queryKey: LEGAL_KEY,
    enabled,
    retry: false,
    queryFn: async () => {
      const result = await readLegalDocuments({ cache: "no-store" });
      if (result.data === undefined) throw new Error("legal documents unavailable");
      return result.data;
    },
  });
}
